import { render } from "./HeaderComponent.vue?vue&type=template&id=dd2b8dea&scoped=true"
const script = {}

import "./HeaderComponent.vue?vue&type=style&index=0&id=dd2b8dea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd2b8dea"]])

export default __exports__